import { Link, useLocation } from '@tanstack/react-router'

import { cn } from '@/lib/utils'

import { type PageTabsItem } from './types'

export interface PageTabsProps {
  items: PageTabsItem[]
}

export const PageTabs = ({ items }: PageTabsProps) => {
  const { pathname } = useLocation()

  return (
    <div className={cn('flex space-x-4')}>
      {items.map(({ label, value, to }) => {
        const isActiveTab = pathname.includes(to ?? '')
        return (
          <Link
            key={value}
            to={to}
            className={cn('flex flex-col', 'text-xl font-semibold', {
              'text-foreground': isActiveTab,
              'text-slate-300': !isActiveTab,
            })}
          >
            <span>{label}</span>
            {isActiveTab && <span className={cn('block', 'mt-1', 'w-full', 'h-[2px]', 'bg-black')} />}
          </Link>
        )
      })}
    </div>
  )
}
